import { useFilePreview } from "@/hooks/context/FilePreviewContext";
import { downloadByUrl } from "@/utils/download";
import { isPreviewAllowed } from "@/utils/file";
import type { UploadFile } from "antd";
import clsx from "clsx";
import { ArrowDownToLine, Eye, FileText, Trash2 } from "lucide-react";
import styles from "./FileListItem.module.less";

type FileListItemProps = {
  file: UploadFile;
  remove: (url?: string) => void;
  hiddenRemove: boolean;
};
export const FileListItem: React.FC<FileListItemProps> = ({
  file,
  remove,
  hiddenRemove,
}) => {
  const openPreivew = useFilePreview();

  if (!file.url) return null;

  const isAllowed = isPreviewAllowed(file.url);

  return (
    <div className={styles.fileListItem}>
      <div className={styles.fileName}>
        <FileText size={14} color="#4E5969" />
        {file.name}
      </div>

      {/* 预览 */}
      <Eye
        size={14}
        color="#4E5969"
        className={clsx(isAllowed ? styles.icon : styles.iconPreviewNotAllowed)}
        onClick={() => isAllowed && openPreivew(file.url!)}
      />

      {/* 下载 */}
      <ArrowDownToLine
        size={14}
        color="#4E5969"
        className={styles.icon}
        onClick={() => downloadByUrl(file.url!)}
      />

      {/* 删除 */}
      {!hiddenRemove && (
        <Trash2
          size={14}
          color="#4E5969"
          className={styles.icon}
          onClick={() => remove(file.url)}
        />
      )}
    </div>
  );
};
